import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseTrendPrice.module.scss'

import MyhouseTrendPricePeriod from '@Components/atoms/MyhouseTrendPricePeriod'
import MyhouseTrendPriceChart from '@Components/modules/MyhouseTrendPriceChart'
import { formatMoney, MONEY_FORMAT_TYPE } from '@Root/utils/moneyFormatter'
import { PRICE_PROVIDER, PROVIDER, TRADE } from '@Root/contants'

const cx = className.bind(style)

type Props = {
  chart: any
  period: any
  summary: any
  tradeType: any
  setPeriod: (period: number) => void
}

const MyhouseTrendPrice: React.FC<Props> = ({ chart, period, summary, tradeType, setPeriod }: Props) => {
  const getProviderLabel = (provider: string): string => {
    if (provider) {
      return PRICE_PROVIDER[provider as PROVIDER].LABEL
    }
    return ''
  }

  const getBasisDateString = (basisYMD: string): string => {
    if (basisYMD) {
      return [basisYMD.slice(0, 4), basisYMD.slice(4, 6), basisYMD.slice(6, 8)].join('.')
    }
    return ''
  }

  const getFormatValue = (value: number) => {
    return formatMoney(value, MONEY_FORMAT_TYPE.MOBILE)
  }

  return (
    <div className={cx('myhouse_trend_price')}>
      {(tradeType === TRADE.RENT && (
        <>
          {(!!summary?.marketPrice && summary.marketPrice.deposit && (
            <>
              {/* 해당 내용에 임시 처리한 내용으로 css 재정의가 필요합니다. */}
              <em className={cx('myhouse_header_standard')}>{`${getBasisDateString(summary.marketPrice.baseYearMonthDay)}. ${getProviderLabel(summary.provider)} 기준`}</em>
              <div className={cx('myhouse_trend_montly')}>
                <em className={cx('myhouse_montly_text')}>보증금/월세</em>
                <strong className={cx('myhouse_montly_price')}>
                  {getFormatValue(summary.marketPrice.deposit)}/{getFormatValue(summary.marketPrice.rentLowPrice)}~{getFormatValue(summary.marketPrice.rentUpperPrice)}
                </strong>
              </div>
            </>
          )) || <p className={cx('myhouse_nodata_text')}>시세 정보가 없습니다.</p>}
        </>
      )) || (
        <>
          <MyhouseTrendPricePeriod period={period} setPeriod={setPeriod} />
          {chart?.exposeChart && <MyhouseTrendPriceChart chart={chart} />}
          {(!!summary?.marketPrice && (
            <>
              <div className={cx('myhouse_price')}>
                <span className={cx('myhouse_price_title')}>시세</span>
                <em className={cx('myhouse_price_value')}>
                  {getFormatValue(summary.marketPrice.lowPriceLimit)} ~ {getFormatValue(summary.marketPrice.upperPriceLimit)}
                </em>
              </div>
              <div className={cx('myhouse_price_rate')}>
                <span className={cx('myhouse_rate_title')}>매매가 대비 전세가</span>
                <em className={cx('myhouse_rate_value')}>{summary.marketPrice.leasePerDealRate}</em>
              </div>
            </>
          )) || <p className={cx('myhouse_nodata_text')}>시세 정보가 없습니다.</p>}
        </>
      )}
    </div>
  )
}

export default MyhouseTrendPrice
